<template>
  <div>
    <div class="page-body">
      <members-table :data="data" :mode="mode"></members-table>
    </div>
  </div>
</template>

<script>
import QueryMode from '@/mixins/QueryMode'
import { MEMBERS } from '@/libs/fakeData'
import MembersTable from '@/components/Tables/Members'

export default {
  mixins: [QueryMode],
  components: { MembersTable },
  data () {
    return {
      waiting: 3,
      repairing: 17,
      maintenance: 102,
      malfunction: 102,
      data: MEMBERS
    }
  },
  computed: {
    path () {
      return this.$route.path
    }
  }
}
</script>
